
const SettingsTopicsDetailsPage = () => import('frontend/pages/settings/sfm-topics/views/SettingsTopicsDetailsPage')
const SettingsTopicsPage = () => import('frontend/pages/settings/sfm-topics/views/SettingsTopicsPage')
const SettingsSFMAttachmentsPage = () => import('frontend/pages/settings/sfm-checkpoints/views/SettingsSFMAttachmentsPage.vue')
const SettingsSFMCheckpointDetailsPage = () => import('frontend/pages/settings/sfm-checkpoints/views/SettingsSFMCheckpointDetailsPage.vue')
const SettingsSFMCheckpointPage = () => import('frontend/pages/settings/sfm-checkpoints/views/SettingsSFMCheckpointPage.vue')

import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'

export default [
  {
    path: 'topics',
    name: SETTINGS_CARDS_TOKENS.sfmTopics.name,
    component: SettingsTopicsPage,
  },
  {
    path: 'topics/:topicId',
    name: SETTINGS_CARDS_TOKENS.sfmTopicsDetails.name,
    component: SettingsTopicsDetailsPage,
  },
  {
    path: 'sfm-checkpoints-list',
    name: SETTINGS_CARDS_TOKENS.sfmCheckpoints.name,
    component: SettingsSFMCheckpointPage,
  },
  {
    path: 'sfm-checkpoints-details/:checkpointId?',
    name: SETTINGS_CARDS_TOKENS.sfmCheckpointsDetails.name,
    components: {
      default: SettingsSFMCheckpointDetailsPage,
    },
    props: {
      default: (routerInstance) => {
        return {
          checkpointId: routerInstance.params.checkpointId ? Number(routerInstance.params.checkpointId) : null,
        }
      },
    },
  },
  {
    path: 'sfm-attachments',
    name: SETTINGS_CARDS_TOKENS.sfmAttachments.name,
    components: {
      default: SettingsSFMAttachmentsPage,
    },
  },
]
